/* ============================================================
   assets/auto-carousel.js — carousel 自动轮播
   引用行（theme.liquid </head> 前）：
     <script src="{{ 'auto-carousel.js' | asset_url }}" defer></script>
   行为：每 INTERVAL 毫秒自动点一次"下一页"箭头；
        滑到最后自动卷回开头；
        鼠标悬停 / 手指触摸时暂停，离开后恢复；
        切到其它浏览器标签页时暂停（省电）
   想给别的 carousel 也开自动轮播：把它的 section id
   加进下面 SECTION_IDS 数组即可（id 见编辑器 URL 的 section= 参数，
   前面加 "shopify-section-"）
   ============================================================ */
(function () {
  var SECTION_IDS = [
    'shopify-section-template--19166729830498__product_list_EDUBdR', /* Featured collection (Top Picks) */
    'shopify-section-template--19166729830498__collection_list_AbbVew' /* Collection list: Carousel (Brands) */
  ];
  var INTERVAL = 4000; /* 毫秒，想快/慢改这里 */

  function setup(id) {
    var sec = document.getElementById(id);
    if (!sec) return;
    var paused = false;

    sec.addEventListener('mouseenter', function () { paused = true; });
    sec.addEventListener('mouseleave', function () { paused = false; });
    sec.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    sec.addEventListener('touchend', function () {
      setTimeout(function () { paused = false; }, 6000); /* 触摸后 6 秒再恢复 */
    }, { passive: true });

    setInterval(function () {
      if (paused || document.hidden) return;
      var next = [].slice.call(sec.querySelectorAll('button.slideshow-control--next:not([disabled])'))
        .filter(function (b) { return b.offsetParent; })[0]; /* 只点当前可见的那组箭头 */
      if (next) { next.click(); return; }
      /* 到最后一页：滚动容器卷回开头 */
      var scroller = sec.querySelector('slideshow-slides');
      if (scroller) scroller.scrollTo({ left: 0, behavior: 'smooth' });
    }, INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { SECTION_IDS.forEach(setup); });
  } else {
    SECTION_IDS.forEach(setup);
  }
})();